<template>
    <div>
        <template v-if="showNewUnloggedNavbar">
            <HeaderUnlogged />
        </template>
        <template v-else>
            <NavbarUnlogged :prismic-document="navbarDocument" :show-search="false" class="resources-navbar" />
            <ClientOnly v-if="!isMultiLocaleHost">
                <Teleport to="#header-customized-zone-search">
                    <SearchCTA :message="navbarDocument?.data.searchButtonLabel ?? ''" button-class="desktop-rc-search" />
                </Teleport>
                <Teleport to="#header-customized-zone-search-tablet">
                    <SearchCTA :message="navbarDocument?.data.searchButtonLabel ?? ''" button-class="mobile-rc-search" />
                </Teleport>
                <Teleport to="#mobile-nav-search">
                    <SearchCTA :message="navbarDocument?.data.searchButtonLabel ?? ''" />
                </Teleport>
            </ClientOnly>
        </template>

        <div class="page-overlay" />
        <slot />
        <!-- Event when logged in, we want to display this footer -->
        <Footer :always-visible="true" />
    </div>
</template>

<script setup lang="ts">
    import {inject} from 'vue';
    import {ClientOnly, NavbarUnlogged, Footer, HeaderUnlogged} from '#components';
    import {useLocale, useAuth, useNewUnloggedNavbar} from '#imports';
    import {RC_NAVBAR} from '~/app/keys';
    import SearchCTA from '~/components/SearchCTA.vue';

    const navbarDocument = inject(RC_NAVBAR);

    const {loggedIn} = useAuth();
    const {isMultiLocaleHost} = useLocale();
    const showNewUnloggedNavbar = useNewUnloggedNavbar();
</script>

<style lang="scss">
    @use '~/assets/styles/page.scss' as *;
    @include page-style;

    .resources-navbar {
        h2 {
            text-align: left;
        }

        .button-placeholder {
            display: none;
        }

        .desktop-rc-search {
            order: -1;
        }

        .megamenu .item-title * {
            font-family: var(--joy-font-family-title);
        }

        /* stylelint-disable-next-line selector-max-id -- navbar teleport target */
        #mobile-nav-search {
            display: block !important;
        }
    }
</style>
